import React from "react";

const ErrorIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g id="Login" fill="none" fillRule="evenodd">
      <g
        id="Login---Email-or-Password-Invalid"
        transform="translate(-496 -316)"
        fillRule="nonzero"
      >
        <g id="Group-2" transform="translate(472 292)">
          <g id="pending_icon" transform="translate(24 24)">
            <circle id="Oval" fill="#ED125F" cx="12" cy="12" r="12" />
            <g id="Group-2" transform="translate(7 7)" fill="#FFF">
              <g id="exclamation-point" transform="rotate(-45 1.793 .672)">
                <rect id="Rectangle" width="2" height="12" />
              </g>
              <g id="exclamation-point-copy" transform="rotate(45 4.207 10.328)">
                <rect id="Rectangle" width="2" height="12" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default ErrorIcon;
